export enum PaymentCollectionTarget {
  WEBSITE = "website",
  CARD_READER = "card_reader",
  CHECKOUT_SESSION = "checkout_session",
}
